import { useState } from 'react';
import { Play, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

export default function VideoSection() {
  const [selectedVideo, setSelectedVideo] = useState(null);

  // Skjult for nu ifølge ønske
  return null;

  const videos = [
    { 
      title: "Præsentation af Online Tryghed", 
      duration: "1:20",
      videoSrc: "/video/shutterstock_3693597661.mp4"
    },
    { 
      title: "3 tegn på online svindel", 
      duration: "2:45",
      videoSrc: "/video/5977452-uhd_3840_2160_25fps.mp4"
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-[#103B66] mb-4">
            Se hvordan vi hjælper
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl">
            Vi har lavet en række korte videoer, der forklarer, hvordan vi skaber tryghed i din hverdag.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8">
          {videos.map((video, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group cursor-pointer"
              onClick={() => setSelectedVideo(video)}
            >
              <div className="aspect-video bg-slate-100 relative overflow-hidden mb-4 border border-slate-200">
                <div className="absolute inset-0 flex items-center justify-center">
                  <video 
                    src={video.videoSrc}
                    className="absolute inset-0 w-full h-full object-cover opacity-50 group-hover:opacity-70 transition-opacity"
                    autoPlay
                    muted
                    loop
                    playsInline
                  />
                  <div className="relative z-10 w-12 h-12 bg-white flex items-center justify-center text-[#103B66] shadow-lg group-hover:scale-110 transition-transform">
                    <Play className="w-5 h-5 fill-current" />
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 bg-black/50 text-white text-xs px-2 py-1">
                  {video.duration}
                </div>
              </div>
              <h3 className="font-bold text-[#103B66] group-hover:text-slate-600 transition-colors">
                {video.title}
              </h3>
            </motion.div>
          ))}
        </div>
      </div>

      <AnimatePresence>
        {selectedVideo && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/90"
            onClick={() => setSelectedVideo(null)}
          >
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              className="relative w-full max-w-5xl aspect-video bg-black"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={() => setSelectedVideo(null)}
                className="absolute -top-12 right-0 text-white hover:text-slate-300 transition-colors p-2"
              >
                <X className="w-8 h-8" />
              </button>
              <video
                src={selectedVideo.videoSrc}
                className="w-full h-full"
                autoPlay
                controls
                playsInline
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
